// extracted by mini-css-extract-plugin
export default {"inputContainer":"forms-inputContainer-NP8S__","inputLabel":"forms-inputLabel-NgJBT6"};